<div class="container p-0">
    <div class="row align-items-center dashboardTileWrapper p-2">

        <div style="  max-width: 95px; padding-left: 5px !important;" class="col p-0">
            <div class="row align-items-center dateWrapper">
                <!-- <div class="col p-0 filterIconWrapper">
                    <span class="material-icons-outlined p-0">
                        filter_list
                    </span>
                </div> -->
                <div class="col  datelabel" style="padding: 0px 0px 0px 15px !important;" >
                    <div class="row">
                        {{dashBoardDetails.FromDate}}
                    </div>
                    <div class="row">
                        {{dashBoardDetails.Todate}}
                    </div>
                </div>
            </div>
        </div>

        <div style="border-left: 1px solid; " class="col p-0 paymentWrapper">
            <div class="row mainlabel align-items-end justify-content-center">
                ₹{{dashBoardDetails.firstLabelAmount}} <span class="sublabel">{{dashBoardDetails.firstLabelAmountLetter}}/{{dashBoardDetails.firstLabelCount}}</span>
            </div>
            <div class="row secondaryLabel justify-content-center">
                {{dashBoardDetails.firstAmountLabel}}
            </div>
        </div>
        <div style="border-left: 1px solid;" class="col p-0 paymentWrapper">
            <div class="row mainlabel align-items-end justify-content-center">
                ₹{{dashBoardDetails.secondLabelAmount}} <span class="sublabel">{{dashBoardDetails.secondLabelAmountLetter}}/{{dashBoardDetails.secondLabelCount}}</span>
            </div>
            <div class="row secondaryLabel justify-content-center">
                {{dashBoardDetails.secondAmountLabel}}
            </div>
        </div>
    </div>
    <div (click)="changeHidedContentStatus()">
        <div *ngIf="dashBoardDetails.isHidedSectionShow" class="dashBoardExpansionWrapper" [ngClass]="{'isActive':isShowHidedContent}">
            <div *ngIf="isShowHidedContent" style="padding-top: 10px;" class="row align-items-end justify-content-center" [@inOutAnimation] >
                <div *ngIf="isShowHidedContentTile" style="border-left: 1px solid; padding-top: 10px; padding-bottom: 10px;" class="col-8 paymentWrapper innerTile" [@inOutAnimationContent]>
                    <div class="row mainlabel align-items-end justify-content-center">
                        ₹{{dashBoardDetails.hidedLabelAmount}} <span
                            class="sublabel">{{dashBoardDetails.hidedLabelAmountLetter}}/{{dashBoardDetails.hidedLabelCount}}</span>
                    </div>
                    <div class="row secondaryLabel justify-content-center">
                        {{dashBoardDetails.hidedAmountLabel}}
                    </div>
                </div>
            </div>
            <div  class="col-2 align-self-center p-0 expandIcon"[ngClass]="{'isActive':isShowHidedContent}" >
                <span class="material-icons-outlined">
                    expand_more
                </span>
            </div>
        </div>
    </div>
</div>
